import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { UtilityService } from '../../../core/services/utility.service';

@Component({
  selector: 'tt-seasonality',
  templateUrl: './seasonality.component.html',
  styleUrls: ['./seasonality.component.css']
})
export class SeasonalityComponent implements OnInit {
    seasonalityKeyno;

    public edit?: Edit;

    public inputListMonths: MonthItem[] = [];

    public saving = false;

    private total: string = '0';

    constructor(private stateService: StateService, private utility: UtilityService, private datatask: DataTaskService) {
        this.seasonalityKeyno = this.stateService.getStateParams()['seasonality_keyno'];
    }

    private async loadEdit() {
        if (!!this.seasonalityKeyno) {
            this.edit = (await this.datatask.Post(850, { seasonality_keyno: this.seasonalityKeyno }))[0];
        }
    }

    private async loadMonths(): Promise<void> {
        if (!!this.edit) {
            this.inputListMonths = await this.datatask.Post(851, { seasonality_keyno: this.edit?.seasonality_keyno });
        }
    }

    private recalcTotal() {
        if (!!this.edit) {
            this.inputListMonths.forEach((item: any) => {
                this.total += this.utility.parseNumber(item.pst);
            });

            this.edit.total = this.total;
        }
    }

    public onBlurMonths(item: any) {
        if (!!item.pst) {
            this.recalcTotal();
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                this.edit.records = this.inputListMonths;

                await this.datatask.Post(852, this.edit);

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        await this.loadEdit();
        this.loadMonths();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    seasonality_keyno: number;
    seasonality_name: string;
    total: string;
    records: any;
}

interface MonthItem {
    item_id: number;
    seasonality_keyno: number;
    item_name: string;
    pst: string;
    orderby: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('seasonality', {
//        templateUrl: 'views/components/views/seasonality/seasonality.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'seasonalityService', function ($stateParams, stateService, utilityService, seasonalityService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let seasonalityKeyno = $stateParams.seasonality_keyno;

//            vm.model = {
//                edit: {},
//                inputListMonths: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await seasonalityService.getEdit({ seasonality_keyno: seasonalityKeyno }))[0];

//                return loadMonths();
//            }

//            async function loadMonths() {
//                if (utilityService.validateParmsValue(vm.model.edit.seasonality_keyno) !== true) return;

//                return vm.model.inputListMonths = await seasonalityService.listMonths({ seasonality_keyno: vm.model.edit.seasonality_keyno });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region RECALCULATION FUNTION

//            function recalcTotal() {
//                let total = 0;

//                vm.model.inputListMonths.forEach((item) => {
//                    total += utilityService.parseNumber(item.pst);
//                });

//                vm.model.edit.total = total;
//            }

//            // #endregion RECALCULATION FUNTION

//            // #region BUTTON SAVE FUNCTION

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                let saveObject = vm.model.edit;
//                saveObject.records = vm.model.inputListMonths;

//                seasonalityService.saveObj(saveObject).then(function () {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, function () {
//                    vm.model.lockedSave = false;
//                });
//            }

//            // #endregion BUTTON SAVE FUNCTION

//            // #region ON BLUR MULTI FUNCTIONS

//            vm.onBlurMonths = function (item) {
//                if (utilityService.validateParmsValue(item.pst, true) !== true) return;

//                recalcTotal();
//            }

//            // #endregion ON BLUR MULTI FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
